<div class="table-container">
    <table class="stripe" mat-table [dataSource]="dataTable" matSort [trackBy]="trackBy" [matSortDisabled]="!this.sortOn" (matSortChange)="this.sortChange()">
  
        <!-- Header Group Columns
        <ng-container *ngIf="this.tableDef.headerGroups.length > 0">
          <ng-container [matColumnDef]="column.name" *ngFor="let column of this.tableDef.headerGroups" [sticky]="column.sticky">
            <th [attr.colspan]="column.colspan" mat-header-cell *matHeaderCellDef>
              <div class="aip-header-cell-top">{{column.title}}</div>
            </th>              
          </ng-container>
        </ng-container>
        -->

        <!-- Header Columns -->
          <ng-container [matColumnDef]="column.name" *ngFor="let column of this.tableDef.fields" [sticky]="false">
            <ng-container *ngIf="column.hideHeader; else headerTemplate">
              <th class="scnd-header unset-width-header" [ngClass]="filterOn?'no-bottom-border':''" mat-header-cell *matHeaderCellDef></th>
            </ng-container>
            <ng-template #headerTemplate>
              <th class="scnd-header" [ngClass]="filterOn?'no-bottom-border':''" mat-header-cell *matHeaderCellDef mat-sort-header >              
                <div class="aip-header-cell">{{column.label?column.label:column.name}}</div>                                
              </th>
            </ng-template>
                        
            <td mat-cell *matCellDef="let element; let i = index"
            [ngStyle]="{
            'font-weight':column['bold']?'bold':'',
            'text-align':column['align']?column['align']:'',
            'width':column['width']?column['width']:'',
            'display':column['display']?column['display']:''
            }"
            >

              <span *ngIf="(column.logo==undefined || column.logo!='show') && column.goto !=true">{{column['displayname']?element[column.displayname]:element[column.name]}}</span>
              <span *ngIf="column.logo=='show'">
                <span *ngIf="getLogo(element[column.name])!=''" (click)="redirect(element)" style="cursor: pointer;" [ngClass]="column.hasBorder ? 'image-container' : ''" [matTooltip]="element[column.name]" [matTooltipClass]="column.matTooltipClass || ''">
                  <img class="image-fit" [src]="'/logos/'+getLogo(element[column.name])">
                </span>
                <span *ngIf="getLogo(element[column.name])==''">{{column['displayname']?element[column.displayname]:element[column.name]}}</span>
              </span>
              <span *ngIf="column.goto == true">
                <a class="custom-column-link" [routerLink]="[]" [relativeTo]="activatedRoute" [queryParams]="{ a: element.id }" queryParamsHandling="merge" [skipLocationChange]="false" [replaceUrl]="false">
                  <span *ngIf="column.showIconBefore === true && column.iconField && ((column.iconField.field && element[column.iconField.field] === column.iconField.value) || !column.iconField.field)" class="custom-icon">
                    <mat-icon style="font-size:16px;height:16px;width:16px;margin-right:5px;" [title]="column.iconField.iconTitle || ''">{{ column.iconField.icon }}</mat-icon>
                  </span>
                  <span>{{column['displayname']?element[column.displayname]:element[column.name]}}</span>
                </a>
              </span>
            </td>
    
          </ng-container>

    
        <!--
          <ng-container *ngIf="this.tableDef.headerGroups.length > 0">
          <tr mat-header-row class="topheader" *matHeaderRowDef="this.headerGroupColumnsArray; sticky: true"></tr>          
          </ng-container>
        -->

        <ng-container *ngIf="this.filterOn">
            <ng-container [matColumnDef]="column.displayname?column.displayname+'_filter':column.name+'_filter'" *ngFor="let column of this.tableDef.fields" [sticky]="false">            
                <th class="thrd-header" mat-header-cell *matHeaderCellDef>
                    <input *ngIf="!column.hideFilter" [name]="column.displayname?column.displayname:column.name" class="aip-widget-search" matInput (keyup)="applyFilter($event)" placeholder="Filter"> 
                </th>
              </ng-container>    
          </ng-container>        
    
          <tr mat-header-row class="bottomheader aip-background-side" *matHeaderRowDef="headerColumnsArray; sticky: true"></tr>
          
        <ng-container *ngIf="this.filterOn">
            <tr mat-header-row class="filterheader aip-background-side" *matHeaderRowDef="headerColumnsFilterArray" sticky="true"></tr>
        </ng-container>

          <tr class="striperow" mat-row *matRowDef="let row; columns: headerColumnsArray;"
          (click)="clickRow(row)"
          (dblclick)="dblClickEdit(row)"
          [style.background]="selectedRow == row ? 'lightblue !important' : (this.tableDef.tableName==='accounts'&&row['isdeleted']===true?'rgba(0,0,0,.12) !important':'')"
          ></tr>
    </table>          

  </div>     
  
  <div class="aip-pagerflex">

    <div>
    <button class="aip-table-info" [matMenuTriggerFor]="menuExport" mat-icon-button>
      <fa-icon size="lg" icon="file-download"></fa-icon>
    </button>
    <mat-menu #menuExport="matMenu">      
      <button class="aip-button" mat-menu-item (click)="export('xlsx')"><fa-icon size="lg" icon="file-excel"></fa-icon>Excel</button>
      <button class="aip-button" mat-menu-item (click)="export('csv')"><fa-icon size="lg"  icon="file-csv"></fa-icon>CSV</button>
      <button class="aip-button" mat-menu-item (click)="export('json')"><fa-icon size="lg" icon="file-code"></fa-icon>JSON</button>
    </mat-menu>   

    <button class="aip-table-info" matTooltip="Refresh Data" mat-icon-button (click)="reloadData()">
      <mat-icon >refresh</mat-icon>
    </button>
  </div>
  <mat-paginator [ngClass]="this.pagedOn?'':'aip-hide-page'" #paginator class="paginator-fullscreen"
    [pageSize]="isTotalData ? 50 : pageSize"
    [pageIndex]="isTotalData ? 0 : pageIndex"
    [length]="isTotalData ? 0 : pageLength"
    [pageSizeOptions]="[25, 50, 100]"
    showFirstLastButtons
    (page)="pageChange()"
    >
  </mat-paginator>
</div>
<div *ngIf="!this.pagedOn" class="bottom-fullscreen"></div>


   

